import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import RouterWrapper from './ThemeWrapper/RouterWrapper';

export function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? [
    parseInt(result[1], 16),
    parseInt(result[2], 16),
    parseInt(result[3], 16),
  ] : null;
}

export function ThemeWrapperImpl({ brand, alwaysRender, children }) {
  const palette = {
    logoBGColor: brand.logoBGColor,
    primary: {
      main: brand.primary1Color,
    },
    secondary: {
      main: brand.accent1Color,
    },
  };
  const theme = createMuiTheme({
    palette,
    typography: {
      useNextVariants: true,
      fontFamily: brand.fontFamily,
      fontWeightMedium: brand.fontWeightMedium,
    },
    shape: {
      borderRadius: '0px',
    },
    shadows: ['none', 'none'],
  });
  theme.palette.primary2 = theme.palette.augmentColor({ main: brand.primary2Color });
  theme.palette.primary3 = theme.palette.augmentColor({ main: brand.primary3Color });
  const [r, g, b] = hexToRgb(theme.palette.primary.main);
  theme.palette.background.default = brand.backgroundColor
    ? brand.backgroundColor : `rgba(${r},${g},${b}, 0.05)`;
  document.body.style = `background: ${theme.palette.background.default};`;
  return (
    <MuiThemeProvider theme={theme}>
      <RouterWrapper alwaysRender={alwaysRender}>{children}</RouterWrapper>
    </MuiThemeProvider>
  );
}

const brandProps = PropTypes.shape({
  name: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
  primary1Color: PropTypes.string.isRequired,
  accent1Color: PropTypes.string.isRequired,
  primary2Color: PropTypes.string.isRequired,
  primary3Color: PropTypes.string.isRequired,
  logoBGColor: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  fontFamily: PropTypes.string.isRequired,
  fontWeightMedium: PropTypes.number.isRequired,
});

const themeWrapperProps = {
  brand: brandProps.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  alwaysRender: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

const themeWrapperDefaultProps = {
  children: [],
  alwaysRender: [],
};

ThemeWrapperImpl.propTypes = themeWrapperProps;
ThemeWrapperImpl.defaultProps = themeWrapperDefaultProps;

export function mapStateToProps(state) {
  return {
    brand: state.brand.brand,
  };
}

export default connect(mapStateToProps)(ThemeWrapperImpl);
